export default { BE: '', ENV: '', UI: '' };
